/**
 * Tick label kategori untuk bar chart horizontal (kartu Pekerjaan & Sektor).
 *
 * Recharts tidak punya cara bawaan menampilkan teks penuh dari label yang
 * dipotong. `tickFormatter` sebelumnya memotong jadi `…` tanpa jalan untuk
 * melihat aslinya, sehingga informasi hilang permanen bagi pembaca. Tick ini
 * memotong dengan ambang yang lebih longgar dan menyisipkan `<title>` SVG —
 * elemen standar, tidak butuh dependency tooltip tambahan.
 */

/** Potong label dan sisipkan elipsis hanya bila benar-benar melewati ambang. */
export function truncateLabel(value: string, maxChars: number): string {
	return value.length > maxChars ? `${value.slice(0, maxChars - 1)}…` : value;
}

interface CategoryTickProps {
	/** Diisi Recharts saat merender tiap tick. */
	x?: number;
	y?: number;
	payload?: { value?: unknown };
	fill: string;
	fontSize: number;
	maxChars: number;
}

export const CategoryTick = ({
	x = 0,
	y = 0,
	payload,
	fill,
	fontSize,
	maxChars,
}: CategoryTickProps) => {
	const full = String(payload?.value ?? "");
	const shown = truncateLabel(full, maxChars);

	return (
		<text x={x} y={y} dy={4} textAnchor="end" fill={fill} fontSize={fontSize}>
			{/* Teks penuh tetap terjangkau saat label dipotong. */}
			{shown !== full && <title>{full}</title>}
			{shown}
		</text>
	);
};
